import React, {useEffect, useState} from 'react'
import {Button, Modal, Popconfirm, Select, Tag} from 'antd'
import {useTranslation} from 'react-i18next'
import {APIv1} from '../../api'
import {versionStatusTag} from '../../utils/version/version_status_tag'
import {getAuthHeaders} from './version.config'

const ChangeVersionModal = ({open, onClose, onSubmit, submitting, count, confirmKey, token, versionsEndpoint, currentVersionId}) => {
    const {t} = useTranslation()
    const [versions, setVersions] = useState([])
    const [loading, setLoading] = useState(false)
    const [targetId, setTargetId] = useState(null)

    useEffect(() => {
        if (!open || !token) return

        setTargetId(null)

        const fetchVersions = async () => {
            setLoading(true)
            try {
                const response = await APIv1.get(versionsEndpoint, {
                    headers: getAuthHeaders(token),
                })
                const items = Array.isArray(response.data)
                    ? response.data
                    : response.data?.results || []

                setVersions(items.filter(item => String(item.id) !== String(currentVersionId)))
            } catch (error) {
                console.error('Something went wrong:', error)
            } finally {
                setLoading(false)
            }
        }

        fetchVersions()
    }, [open, token, versionsEndpoint, currentVersionId])

    const target = versions.find(item => item.id === targetId)

    return (
        <Modal
            centered
            destroyOnClose
            title={t('pages.versions.detail.related.change.title')}
            open={open}
            width={420}
            onCancel={() => !submitting && onClose()}
            footer={[
                <Button key='cancel' disabled={submitting} onClick={onClose}>
                    {t('pages.versions.detail.related.change.cancel')}
                </Button>,
                <Popconfirm
                    key='submit'
                    title={t('pages.versions.detail.related.change.confirmTitle')}
                    description={t(confirmKey, {count, version: target?.version_number})}
                    okText={t('pages.versions.detail.related.change.submit')}
                    cancelText={t('pages.versions.detail.related.change.cancel')}
                    onConfirm={() => onSubmit(target)}
                    disabled={!target}
                >
                    <Button type='primary' disabled={!target} loading={submitting}>
                        {t('pages.versions.detail.related.change.submit')}
                    </Button>
                </Popconfirm>,
            ]}
        >
            <p>{t('pages.versions.detail.related.change.selected', {count})}</p>
            <Select
                showSearch
                style={{width: '100%'}}
                placeholder={t('pages.versions.detail.related.change.placeholder')}
                loading={loading}
                value={targetId}
                virtual={false}
                onChange={setTargetId}
                optionFilterProp='label'
                options={versions.map(item => ({value: item.id, label: item.version_number, status: item.status}))}
                optionRender={option => {
                    const statusTag = versionStatusTag(option.data.status) || {}

                    return (
                        <div className='change-version-modal__option'>
                            <span>{option.data.label}</span>
                            {option.data.status && (
                                <Tag bordered={false} color={statusTag.color || 'default'}>
                                    {statusTag.icon} {option.data.status}
                                </Tag>
                            )}
                        </div>
                    )
                }}
            />
        </Modal>
    )
}

export default ChangeVersionModal
